import React from 'react';
import PropTypes from 'prop-types';
import Table from 'cccisd-table';
import { round } from 'lodash';

const EvaluatorTypeTable = props => {
    const { data } = props;

    const labels = {
        1: {
            label: 'Internal Staff',
            name: 'internal',
        },
        2: {
            label: 'External Evaluator',
            name: 'external',
        },
    };

    const getData = d => {
        const rows = [];
        for (var c of Object.keys(d)) {
            const cc = props.data[c];
            const row = {
                cc: c,
                careCoord: c.split(',')[0],
                internal: 0,
                external: 0,
                ccTotal: 0,
            };
            for (var e of ['internal', 'external']) {
                if (cc[e]) {
                    row[e] += cc[e];
                    row.ccTotal += cc[e];
                }
            }
            rows.push(row);
        }
        return rows;
    };

    const getTotalRow = td => {
        let total = { internal: 0, external: 0, ccTotal: 0 };
        for (var row of td) {
            total.internal += row.internal;
            total.external += row.external;
            total.ccTotal += row.ccTotal;
        }
        return {
            careCoord: 'Total:',
            cc: 'total',
            internal: `${total.internal} (${round((total.internal / total.ccTotal) * 100, 2)}%)`,
            external: `${total.external} (${round((total.external / total.ccTotal) * 100, 2)}%)`,
        };
    };

    const cols = [
        {
            name: 'careCoord',
            label: 'Care Coordinator',
            sort: true,
            filter: true,
        },
        ...Object.keys(labels).map(n => ({
            name: labels[n].name,
            label: labels[n].label,
            sort: true,
            render(value, row) {
                return value > 0 ? `${value} (${round((value / row.ccTotal) * 100, 2)}%)` : 0;
            },
        })),
    ];

    const tableData = getData(data);
    const totalRow = getTotalRow(tableData);

    return (
        <Table
            data={tableData}
            rowKey="cc"
            orderBy="careCoord"
            columns={cols}
            showPerPageOptions={false}
            footer={totalRow}
            isCsvDownload
        />
    );
};

EvaluatorTypeTable.propTypes = {
    data: PropTypes.object,
};

export default EvaluatorTypeTable;
